import {
  Module,
  VuexModule,
  Action,
  Mutation,
  getModule
} from 'vuex-module-decorators'
import Vue from 'vue'

import store from '@/store'
import dealModule from './deal'

const name = 'event'
@Module({
  namespaced: true,
  dynamic: true,
  name,
  store
})
class EventModule extends VuexModule {
  private currentMessage = ''
  private currentColor = 'success'
  private currentSearch = ''
  private currentLoading = false
  private currentFilters: Record<string, string[]> = {}

  get searchTerm() {
    return this.currentSearch
  }

  get message() {
    return this.currentMessage
  }

  get color() {
    return this.currentColor
  }

  get loading() {
    return this.currentLoading
  }

  get filters() {
    return this.currentFilters
  }

  @Mutation
  private setMessage(payload: string) {
    this.currentMessage = payload
  }

  @Mutation
  private setColor(payload: string) {
    this.currentColor = payload
  }

  @Mutation
  private setCurrentSearch(payload: string) {
    Vue.set(this, 'currentSearch', payload.trim())
  }

  @Mutation
  private setCurrentLoading(loading: boolean) {
    this.currentLoading = loading
  }

  @Mutation
  private setCurrentFilters(filters: Record<string, string[]>) {
    this.currentFilters = filters
  }

  @Action({ rawError: true })
  newError(payload: string) {
    this.context.commit('setColor', 'error')
    this.context.commit('setMessage', payload)
  }

  @Action({ rawError: true })
  newMessage(payload: string) {
    this.context.commit('setColor', 'success')
    this.context.commit('setMessage', payload)
  }

  @Action({ rawError: true })
  newInfo(payload: string) {
    this.context.commit('setColor', 'info')
    this.context.commit('setMessage', payload)
  }

  @Action({ rawError: true })
  resetMessage() {
    this.context.commit('setMessage', '')
  }

  @Action({ rawError: true })
  async setSearch(payload: string) {
    this.context.commit('setCurrentSearch', payload)
    await dealModule.fetchAll()
  }

  @Action({ rawError: true })
  setLoading(loading: boolean) {
    this.context.commit('setCurrentLoading', loading)
  }

  @Action({ rawError: true })
  setFilters(filters: Record<string, string[]>) {
    this.context.commit('setCurrentFilters', filters)
  }
}

export default getModule(EventModule)
